<app-organisation-selector [orgTree]="organisationTree!"
                           (organisationSelected)="addOrganisation($event)"
                           [clearAfterSelection]="true"
                           #orgSelector
                           placeholder=""
                           customId="organisation-select-user-form"
></app-organisation-selector>
<div class="mt-2">
  <app-selected-organisations-panel
      [items]="organisationsForm.value"
      (itemClicked)="removeOrganisation($event)"
  >
  </app-selected-organisations-panel>
</div>